import { Injectable, inject } from '@angular/core';
import { MathComputationService } from './math-computation.service';

@Injectable({
    providedIn: 'root',
})
export class TvpiIrrFormatService {
    private mathService = inject(MathComputationService);

    noChangeText = 'No Change from Prior Quarter';
    priorQuarterText = 'Prior Quarter : ';
    nAText = 'N/A';
    nMText = 'N/M';
    iconSet: Record<string, string> = {};

    deriveIrrAndTvpiIconAndTitle(
        qoQChange: number | null,
        currentValue: number,
        priorValue: number,
        iconSet: Record<string, string>,
        summary: object,
        isTvpiValue?: boolean
    ) {
        this.iconSet = iconSet;
        priorValue = priorValue ?? 0.0;
        const icon = this.deriveIrrAndTvpiIcon(qoQChange, currentValue, priorValue, !!isTvpiValue);
        const title = this.deriveIrrAndTvpiTitle(qoQChange, currentValue, priorValue, !!isTvpiValue);
        if (summary) {
            const record = summary as Record<string, unknown>;
            if (isTvpiValue) {
                record['tvpiIcon'] = icon;
                record['tvpiTitle'] = title;
            } else {
                record['irrIcon'] = icon;
                record['irrTitle'] = title;
            }
        }
    }

    private deriveIrrAndTvpiIcon(qoQChange: number | null, currentValue: number, priorValue: number, isTvpiValue: boolean) {
        if (qoQChange !== null && !isNaN(qoQChange)) {
            const formattedQoQValue =
                Number(this.mathService.roundNumber(currentValue, 1, isTvpiValue ? 2 : 3)) -
                Number(this.mathService.roundNumber(priorValue, 1, isTvpiValue ? 2 : 3));
            return formattedQoQValue > 0
                ? this.iconSet['icon.increase']
                : formattedQoQValue < 0
                    ? this.iconSet['icon.decrease']
                    : this.iconSet['icon.noChange'];
        } else {
            return null;
        }
    }

    private deriveIrrAndTvpiTitle(qoQChange: number | null, currentValue: number, priorValue: number, isTvpiValue: boolean) {
        if (qoQChange !== null && !isNaN(qoQChange)) {
            let title: string;
            const formattedQoQValue =
                Number(this.mathService.roundNumber(currentValue, 1, isTvpiValue ? 2 : 3)) -
                Number(this.mathService.roundNumber(priorValue, 1, isTvpiValue ? 2 : 3));
            if (formattedQoQValue > 0 || formattedQoQValue < 0) {
                if (isTvpiValue) {
                    title = this.priorQuarterText + this.getTvpiValue(priorValue);
                } else {
                    title = this.priorQuarterText + this.getIrrValue(priorValue);
                }
            } else {
                title = this.noChangeText;
            }
            return title;
        } else {
            return this.nAText;
        }
    }
    
    getIrrValue(value: number | null | undefined) {
        if (value !== undefined && value !== null) {
            if (value === 0) {
                return '-';
            }
            else {
                return (value * 100).toFixed(1) === '-0.0' ? '(0.0%)' : ((value < 0) ? '(' + Math.abs(Number(this.mathService.roundNumber(value * 100, 1, 1))) + '%)' : this.mathService.roundNumber(value * 100, 1, 1) + '%');
            }
        }
        else {
            return this.nMText;
        }
    }

    getTvpiValue(value: number | null | undefined, negativeZeroValueWithParenthesis?: boolean) {
        if (value !== undefined && value !== null) {
            if (value === 0) {
                return '-';
            } else {
                if (negativeZeroValueWithParenthesis) {
                    return value.toFixed(2) === '-0.00'
                        ? '(0.00x)'
                        : value < 0
                            ? '(' + Math.abs(Number(this.mathService.roundNumber(value, 1, 2))) + 'x)'
                            : this.mathService.roundNumber(value, 1, 2) + 'x';
                } else {
                    return value.toFixed(2) === '-0.00'
                        ? '0.00x'
                        : value < 0
                            ? '(' + Math.abs(Number(this.mathService.roundNumber(value, 1, 2))) + 'x)'
                            : this.mathService.roundNumber(value, 1, 2) + 'x';
                }
            }
        } else {
            return this.nMText;
        }
    }
}
